<body>
  <h4>{{pearName}}</h4>
  <svg id="chart" width='500' height='250'></svg>
  <div id="legend">
    <h5>{{ 'RISK.LEGEND' | translate }}</h5>
    <span><svg style="height: 30px;width:20px;">
        <path class="point" d="M0,4.51351666838205A4.51351666838205,4.51351666838205 0 1,1 0,-4.51351666838205A4.51351666838205,4.51351666838205 0 1,1 0,4.51351666838205Z"
          transform="translate(10,25)"></path>
      </svg>Potential Risk</span><br />
    <span><svg style="height: 30px;width:20px;">
        <path class="point" d="M-4,-4L4,-4 4,4 -4,4Z" transform="translate(10,25)"></path>
      </svg>Residual Risk</span><br />
    <span><svg style="height: 30px;width:20px;">
        <path class="point" d="M0,-5.26429605180997L6.078685485212741,5.26429605180997 -6.078685485212741,5.26429605180997Z"
          transform="translate(10,25)"></path>
      </svg>Current Risk</span><br />
  </div>
</body>